import { httpClient } from './index';

export const fetchClientAvailability = async (provider, dateRange, offset, tenancyIds) => {
  const params = {
    providerId: provider.id,
    range: dateRange,
    offset: offset,
    tenancyIds
  };
  const result = await httpClient.post(
    `/api/search/availability/fetch`,
    params
  );
  return result.data;
};

export const fetchNextAvailability = async (provider, earliestTime, tenancyIds) => {
  const params = { providerId: provider.id, earliestTime, tenancyIds };
  const result = await httpClient.post(
    `/api/search/availability/fetchNext`,
    params
  );
  return result.data;
};

export const fetchTenancy = async tenancyId => {
  const params = { tenancyId };
  const result = await httpClient.post(`/api/search/tenancies/fetch`, params);
  return result.data;
};

export const createAppointmentRequest = async params => {
  const result = await httpClient.post(
    `/api/search/appointment-request`,
    params
  );
  return result.data;
}; 
